import styled from 'styled-components';
import { Button } from '@shortlyster/ui-kit';

export const Container = styled.div({
  '.capital': {
    textTransform: 'capitalize',
  },
});

export const StyledButton = styled(Button)`
  border-radius: 6px;
  padding-top: 3px;
  height: 32px;
  margin: 10px 0 10px 0;
  & > div > svg {
    margin-bottom: 1px;
  }
`;
